import { render, staticRenderFns } from "./Player2.vue?vue&type=template&id=25d2d506&scoped=true&"
import script from "./Player2.vue?vue&type=script&lang=js&"
export * from "./Player2.vue?vue&type=script&lang=js&"
import style0 from "./Player2.vue?vue&type=style&index=0&id=25d2d506&prod&lang=css&"
import style1 from "./Player2.vue?vue&type=style&index=1&id=25d2d506&prod&lang=scss&scoped=true&"
import style2 from "./Player2.vue?vue&type=style&index=2&id=25d2d506&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d2d506",
  null
  
)

export default component.exports